export default {
  auth: {
    loginTitle: 'おかえりなさい',
    loginSubtitle: 'ログインして視聴を続けましょう。',
    registerTitle: 'アカウント作成',
    registerSubtitle: '電話番号またはメールで登録して視聴を始めましょう。',
    account: 'アカウント',
    accountPlaceholder: '電話番号またはメールを入力',
    phoneTab: '電話番号',
    emailTab: 'メール',
    phone: '電話番号',
    phonePlaceholder: '電話番号を入力',
    email: 'メール',
    emailPlaceholder: 'メールを入力',
    nickname: 'ニックネーム',
    nicknamePlaceholder: 'ニックネームを入力',
    password: 'パスワード',
    passwordPlaceholder: 'パスワードを入力',
    repassword: '確認',
    repasswordPlaceholder: 'もう一度入力',
    loginAction: 'ログイン',
    loginLoading: 'ログイン中...',
    registerAction: '登録',
    agreementPrefix: '以下を確認し、同意しました',
    noAccount: 'アカウントをお持ちでないですか？',
    hasAccount: 'すでにアカウントをお持ちですか？',
    goRegister: '登録',
    goLogin: 'ログイン',
    agreementRequired: '先に規約に同意してください',
    accountRequired: 'アカウントを入力してください',
    passwordRequired: 'パスワードを入力してください',
    invalidPhone: '電話番号が正しくありません',
    invalidEmail: 'メールアドレスが正しくありません',
    invalidNickname: 'ニックネームは2文字以上で入力してください',
    invalidPassword: 'パスワードは6文字以上で入力してください',
    passwordMismatch: 'パスワードが一致しません',
    registerReady: '登録情報の入力が完了しました',
    registerSuccess: '登録が完了しました',
    registerFailed: 'このアカウントは既に存在するか、形式が正しくありません'
  },
  settings: {
    title: '設定',
    editProfile: 'プロフィール編集',
    editProfileDesc: 'ニックネームやプロフィールを変更します',
    changePassword: 'パスワード変更',
    changePasswordDesc: 'アカウントを安全に保ちます',
    logout: 'ログアウト',
    logoutDesc: 'この端末からログアウトします',
    logoutConfirmTitle: 'ログアウトしますか？',
    logoutConfirmMessage: 'このアカウントを使うには、再ログインが必要です。',
    logoutConfirmAction: 'ログアウト',
    logoutSuccess: 'ログアウトしました',
    cancel: 'キャンセル',
    uploadAvatar: 'アップロード',
    uploading: 'アップロード中...',
    uploadSuccess: 'アバターをアップロードしました',
    uploadFailed: 'アバターのアップロードに失敗しました',
    invalidAvatar: '画像ファイルを選択してください',
    save: '保存',
    saving: '保存中...',
    profileEmpty: 'ニックネームを入力するか、アバターをアップロードしてください',
    invalidNickname: 'ニックネームは2文字以上で入力してください',
    profileUpdateSuccess: 'プロフィールを更新しました',
    profileUpdateFailed: 'プロフィールの更新に失敗しました',
    oldPassword: '現在',
    oldPasswordPlaceholder: '現在のパスワード',
    newPassword: '新規',
    newPasswordPlaceholder: '新しいパスワード',
    confirmPassword: '確認',
    confirmPasswordPlaceholder: 'もう一度入力',
    passwordRequired: '新しいパスワードを入力してください',
    passwordUpdateSuccess: 'パスワードを変更しました',
    passwordUpdateFailed: 'パスワードの変更に失敗しました'
  },
  common: {
    back: '戻る'
  },
  login: {
    submitText: 'ワンタップログイン',
    errorAccount: 'アカウントまたはパスワードが違います'
  },
  legal: {
    and: 'と',
    suffix: 'に同意してからご利用ください',
    policy: 'プライバシーポリシー',
    terms: '利用規約'
  },
  favorite: {
    empty: 'お気に入りはまだありません'
  },
  history: {
    continue: '続きを見る',
    watched: '視聴履歴',
    empty: '視聴履歴はまだありません',
    ongoing: '配信中',
    completed: '完結',
    loading: '読み込み中...',
    noMore: 'これ以上ありません',
    loadMore: 'もっと見る'
  },
  profile: {
    loginTitle: 'ログインしてください',
    loginDesc: 'お気に入りや視聴履歴を利用できます',
    loginBtn: 'ログイン',
    guest: 'ゲスト',
    userId: 'ID',
    balance: '残高を見る',
    pointsBalance: '残高',
    memberBadge: '会員',
    recharge: 'チャージ',
    subscriptionTitle: 'サブスクリプション',
    subscriptionDesc: 'お得な視聴プランを見る',
    subscriptionBtn: '見る',
    logout: 'ログアウト',
    menu: {
      recharge: 'チャージ',
      favorite: 'お気に入り',
      history: '視聴履歴',
      rechargeHistory: 'チャージ履歴',
      contact: 'お問い合わせ'
    },
    contact: {
      support: 'カスタマーサポート'
    }
  },
  video: {
    totalEpisodes: '全{num}話',
    myPage: 'マイページ',
    favorite: 'お気に入り',
    episodes: 'エピソード',

    playingEpisode: '第{num}話を再生中',
    episodeUnit: '第{num}話',

    buyTitle: '購入',
    buySubtitle: '続ける方法を選択してください',

    buySingle: 'このエピソードを購入',
    buySingleDesc: 'このエピソードだけ見る',

    buyAll: '全話購入',
    buyAllDesc: 'すべてのエピソードを視聴できます',
    unlockPrice: '価格:',
    episodeShort: '話',
    unlockNextEpisodes: '次の{count}話',
    unlockRemainingEpisodes: '残りをすべて解除',
    unlockAllEpisodes: 'すべて解除',
    upgradeSubscription: 'サブスクリプションをアップグレード',
    myBalance: '残高',
    rechargeNow: 'チャージ',
    chooseSubscriptionPackage: 'サブスクリプションを選択',
    balancePurchase: '残高で購入',
    subscriptionPrivilege: '特典パッケージを登録',
    unlockCost: '解除価格',
    popular: '人気',
    pass: 'パス',
    days: '日',
    subscriptionTitle: 'サブスクリプション',
    subscriptionHint: '左右にスワイプ',
    subscriptionDefault: 'おすすめ',
    subscriptionDays: '{days}日',
    subscriptionAction: 'このプランで登録',
    subscriptionUnavailable: 'サブスクリプションは利用できません',
    createSubscriptionOrderFail: 'サブスクリプション注文の作成に失敗しました',
    subscriptionSuccess: 'サブスクリプション登録が完了しました',
    subscriptionCancel: 'サブスクリプションをキャンセルしました',
    billingWeekly: '週間',
    billingMonthly: '月間',
    billingHalfYearly: '半年',
    billingYearly: '年間',

    loading: '読み込み中...',

    noDataError: 'エピソードデータに問題があります',

    createOrderFail: '注文の作成に失敗しました',
    missingOrderId: 'trade_order_id がありません',

    insufficientBalance: '残高が足りません。先にチャージしてください。',

    paying: '決済処理中...',
    payCancel: '決済をキャンセルしました',

    rechargeSuccess: 'チャージしました',
    rechargeFail: 'チャージに失敗またはキャンセルされました',
    orderCheckFail: '注文確認に失敗しました',
    buySuccess: '購入しました',
    unlockSuccess: 'ロックを解除しました',
    payFail: '決済に失敗しました',
    payProcessing: '決済処理中です。あとで確認してください'
  },
  recharge: {
    currency: 'JPY',
    title: 'チャージ',

    selectAmount: '金額を選択',

    noticeTitle: '注意事項',

    notice1: '※ ポイントはデジタル商品です。購入後すぐに利用できます。',
    notice2: '※ 1 Bean = 1コインです。',
    notice3: '※ ポイント、ボーナスポイント、VIP特典はデジタル商品です。',
    notice4: '※ 返金時は、返金額に応じて購入済み作品の視聴権が取り消されます。',
    notice5: '※ 一部返金の場合、該当する視聴権のみ取り消されます。',
    notice6: '※ 残高、使用済みポイント、ボーナス、取り消し済み視聴権は各プラットフォームの返金ルールに従います。',
    btn: 'チャージ',
    success: '決済が完了しました',

    footnote: '※ 決済後、ポイントはすぐに反映されます。',

    createOrderFail: '注文の作成に失敗しました',
    rechargeError: 'チャージに失敗しました',
    processing: '決済処理中',
    cancelled: '決済をキャンセルしました'
  },
  subscription: {
    title: 'サブスクリプション',
    loading: '読み込み中...',
    empty: '利用できるプランはありません',
    loadFail: 'プランの読み込みに失敗しました',
    processing: '処理中...',
    selectPlan: 'プランを選択してください',
    currentSubscription: '現在のサブスクリプション',
    current: '利用中',
    status: 'ステータス',
    validUntil: '有効期限',
    nextRenewal: '次回更新',
    statusActive: '有効',
    statusCancelledValid: '解約済み・期限まで有効',
    statusInactive: '無効',
    reactivate: '再開する',
    upgrade: 'プラン変更',
    unavailable: 'サブスクリプションは利用できません',
    currentPlan: '現在のプラン',
    currentPlanToast: '現在利用中のプランです',
    changeTip: '有効なサブスクリプションがあります。別のプランに変更できます。',
    reactivateTip: '解約済みですが、期限内です。自動更新を再開できます。',
    blockingTip: 'すでにサブスクリプションがあります。期限後に新しいプランを購入できます。',
    cannotReactivate: 'このサブスクリプションは再開できません',
    cannotChange: '今はプランを変更できません'
  },
  checkout: {
    title: 'お支払い',
    qrisStandard: 'インドネシア標準',
    qrisPay: 'QRIS決済',
    qrisHint: 'QRIS対応の銀行アプリまたは電子ウォレットで読み取ってください。',
    scanTitle: 'QRコードでお支払い',
    scanDesc: '決済アプリでQRコードを読み取り、支払いを完了してください。',
    qrAlt: '支払い用QRコード',
    qrUnavailable: 'QRコードを表示できません',
    waiting: '支払い待ち',
    paid: '支払いが完了しました',
    orderNo: '注文番号',
    cancelPayment: '支払いをキャンセル',
    cancelled: '支払いをキャンセルしました'
  },
  category: {
    title: 'カテゴリ',
    noData: 'データがありません',
    loadFail: 'カテゴリの読み込みに失敗しました'
  },
  orderHistory: {
    title: '注文履歴',
    empty: '注文はまだありません',
    orderNo: '注文番号',
    amount: '金額',
    status: 'ステータス',
    time: '日付',
    loading: '読み込み中...',
    loadEnd: 'すべて読み込みました',
    currency: 'JPY',
    statusMap: {
      completed: '完了',
      pending: '保留中',
      cancelled: 'キャンセル',
      failed: '失敗'
    },
    productName: '商品',
    unitCoin: 'コイン'
  },
  tab: {
    home: 'ホーム',
    category: 'カテゴリ',
    profile: 'マイページ'
  },
  banner: {
    hotDramaTitle: '人気ドラマ',
    title: 'ショートドラマ一覧',
    menu: 'メニュー'
  },
  search: {
    searchBtn: '検索',
    pageTitle: '検索',
    placeholder: 'キーワードを入力',
    placeInputHolder: 'タイトルや俳優名で検索',
    popularSearch: '人気',
    recentSearch: '最近',
    noHistory: '履歴はありません',
    searchResultOf: '検索結果',
    countUnit: '件',
    noWorks: '結果が見つかりません',
    tags: {
      romance: '恋愛',
      suspense: 'サスペンス',
      comedy: 'コメディ',
      action: 'アクション',
      fantasy: 'ファンタジー',
      historical: '時代劇',
      youth: '青春',
      family: '家族',
      revenge: '復讐',
      business: 'ビジネス',
      urban: '現代',
      campus: '学園',
      marriage: '結婚',
      sweet: '甘い',
      sad: '切ない',
      inspirational: '感動',
      mystery: 'ミステリー',
      crime: '犯罪',
      thriller: 'スリラー',
      completed: '完結',
      ongoing: '配信中',
      new: '新着'
    }
  },
  privacy: {
    title: 'プライバシーポリシー',
    backLabel: '戻る',
    section1: {
      title: '1. 概要',
      content: 'このポリシーは、OttDramaがユーザーデータをどのように扱うかを説明します。法令を守り、個人情報を適切に保護します。'
    },
    section2: {
      title: '2. 取得する情報',
      intro: '以下の情報を取得する場合があります。',
      items: [
        'アカウント情報（メール、ユーザー名など）',
        '利用情報（視聴履歴、検索、 お気に入りなど）',
        '端末情報（OS、端末モデル、アプリバージョンなど）',
        '技術情報（IP、Cookie、広告IDなど）',
        'お問い合わせ内容と対応履歴'
      ]
    },
    section3: {
      title: '3. 利用目的',
      intro: '取得した情報は以下の目的で利用します。',
      items: [
        'サービスの提供と改善',
        'ユーザーサポート',
        '安全性の確保',
        '利用状況の分析',
        '新機能の案内',
        '法令対応'
      ]
    },
    section4: {
      title: '4. 決済',
      para1: 'Apple App StoreやGoogle Playなどの決済プラットフォームを利用する場合があります。',
      para2: '決済情報は当社では保存せず、各プラットフォームで管理されます。'
    },
    section5: {
      title: '5. 第三者提供',
      intro: '以下の場合を除き、データを第三者へ提供しません。',
      items: [
        '本人の同意がある場合',
        '法令に基づく場合',
        '安全や財産を守るために必要な場合',
        '公衆衛生や児童保護のために必要な場合'
      ]
    },
    section6: {
      title: '6. 外部サービス',
      intro: '以下の外部サービスを利用する場合があります。',
      items: [
        'アクセス解析ツール',
        '広告サービス',
        'クラッシュレポートツール'
      ],
      additionalNote: 'これらは匿名データを収集する場合があります。'
    },
    section7: {
      title: '7. Cookie',
      para1: '利便性向上や利用分析のため、Cookieを使用する場合があります。',
      para2: 'Cookieは無効にできますが、一部機能が使えない場合があります。'
    },
    section8: {
      title: '8. データ保護',
      content: 'データを守るため、合理的な安全対策を行います。'
    },
    section9: {
      title: '9. ユーザーの権利',
      para1: 'データの開示、訂正、削除を求めることができます。',
      para2: 'ご希望の場合はお問い合わせください。'
    },
    section10: {
      title: '10. 未成年',
      content: '未成年の利用には保護者の同意が必要です。'
    },
    section11: {
      title: '11. 更新',
      content: 'このポリシーは必要に応じて更新されます。'
    },
    section12: {
      title: '12. お問い合わせ',
      contactLine1: 'お問い合わせはこちら:',
      contactLine2: 'Email: duanjushortvideotv@gmail.com'
    },
    effectiveDate: '制定日: 2026年1月1日'
  },
  agreement: {
    title: '利用規約',
    backLabel: '戻る',
    section1: {
      title: '1. 適用範囲',
      content: 'この規約はOttDramaに適用されます。サービスを利用すると、この規約に同意したものとみなします。'
    },
    section2: {
      title: '2. 登録',
      para1: 'ユーザーは正確な情報で登録してください。',
      para2: '以下の場合、登録をお断りすることがあります。',
      items: [
        '虚偽の情報がある場合',
        '過去に規約違反がある場合',
        'その他、当社が不適切と判断した場合'
      ]
    },
    section3: {
      title: '3. アカウント',
      para1: 'アカウントの管理はユーザーの責任です。',
      para2: '不正利用による損害について、当社は責任を負いません。'
    },
    section4: {
      title: '4. サービス',
      content: '当社はショートドラマなどのコンテンツを提供し、機能を随時更新する場合があります。'
    },
    section5: {
      title: '5. 有料コンテンツ',
      para1: '一部コンテンツは有料です。',
      para2: '価格や条件はアプリ内に表示されます。'
    },
    section6: {
      title: '6. ポイント',
      para1: 'ポイントは購入に利用できます。',
      items: [
        'アプリ内でのみ利用できます',
        '現金への交換はできません',
        '法令で必要な場合を除き返金できません',
        '有効期限が設定される場合があります'
      ]
    },
    section7: {
      title: '7. 決済',
      para1: '決済はAppleやGoogleなどのプラットフォームで処理されます。',
      para2: '購入後の返金は、法令で必要な場合を除きできません。'
    },
    section8: {
      title: '8. 禁止事項',
      intro: '以下の行為は禁止です。',
      items: [
        '法令違反',
        '犯罪行為',
        '他者の権利侵害',
        'サービスの妨害',
        '不正目的での利用',
        'ユーザーデータの収集',
        'なりすまし',
        '不正アクセスやその試み',
        'コンテンツのコピーや配布',
        '運営への妨害',
        'その他不適切な行為'
      ]
    },
    section9: {
      title: '9. 知的財産権',
      para1: 'すべてのコンテンツは当社または権利者に帰属します。',
      para2: '無断利用は禁止です。'
    },
    section10: {
      title: '10. 利用停止',
      intro: '以下の場合、アカウントを停止することがあります。',
      items: [
        '規約違反',
        '虚偽情報',
        '支払い不履行',
        'その他リスクがある場合'
      ]
    },
    section11: {
      title: '11. 未成年',
      content: '未成年の利用には保護者の同意が必要です。'
    },
    section12: {
      title: '12. サービス停止',
      intro: '以下の場合、サービスを停止することがあります。',
      items: [
        'メンテナンス',
        '災害',
        'システム障害',
        'その他必要な場合'
      ]
    },
    section13: {
      title: '13. 免責',
      para1: 'サービスに不具合がないことを保証するものではありません。',
      para2: '重大な過失がある場合を除き、当社は責任を負いません。'
    },
    section14: {
      title: '14. 変更',
      content: 'この規約は必要に応じて更新されます。'
    },
    section15: {
      title: '15. プライバシー',
      content: 'データはプライバシーポリシーに従って扱います。'
    },
    section16: {
      title: '16. 準拠法',
      content: '日本法を準拠法とします。'
    },
    section17: {
      title: '17. お問い合わせ',
      contactLine1: 'お問い合わせはこちら:',
      contactLine2: 'Email: duanjushortvideotv@gmail.com',
      contactLine3: '受付時間: 平日 10:00-17:00'
    }
  },
  contact: {
    greeting: 'お問い合わせ',
    subGreeting: 'ご質問・サポート',
    email: 'メール',
    whatsapp: 'WhatsApp',
    line: 'LINE',
    copyHint: 'タップしてコピー',
    copy: 'コピー',
    message: 'メッセージ',
    addFriend: '友だち追加',
    noteEmail: 'こちらからお問い合わせください',
    noteWhatsapp: '営業時間: 10:00-18:00',
    noteLine: '公式アカウント',
    footerNote: '* 通常24時間以内に返信します。\n* お問い合わせ時は必要な情報をご記入ください。',
    toastCopySuccess: 'コピーしました',
    toastCopyEmail: 'メールアドレス',
    toastCopyWhatsapp: 'WhatsApp番号',
    toastCopyLine: 'LINE ID',
    toastShareSuccess: '共有しました',
    toastShareFail: '共有に失敗しました'
  }
}
